import { Modal } from "bootstrap"
import videojs from "video.js"
import { Widget } from "../lib/widget"
import { $ } from "../lib/dom"

class AccountView extends Widget {
  constructor() {
    super()
    this.delegate("click", "#select-all-documents", this.selectAll)
    this.delegate("click", "#select-all-manuals", this.selectManuals)
  }

  selectAll(event) {
    event.preventDefault()
    this.$("input[name='document_ids[]']").prop("checked", true)
  }

  selectManuals(event) {
    event.preventDefault()
    this.$("input[name='document_ids[]']").prop("checked", false)
    this.$("input[name='document_ids[]'][data-manual='true']").prop("checked", true)
  }
}

class UserView extends Widget {
  constructor() {
    super()
    this.delegate("click", ".tab", this.openTab)
    this.delegate("click", "#email_password_save_button", this.confirmEmailChange)
  }

  openTab(event, tab) {
    event.preventDefault()
    this.$(".tab-content").hide()
    this.$(".tab").removeClass("active")
    this.$(`#${tab.dataset.tab}`).show()
    tab.classList.add("active")
  }

  confirmEmailChange(event) {
    const field = this.$("#user_email")
    if (field.data("original-email") !== field.val() &&
        !window.confirm("Changing your email will change the email you use to login, are you sure you want to update it?")) {
      event.preventDefault()
    }
  }
}

class CoursesView extends Widget {
  constructor() {
    super()
    this.delegate("click", "#show-archived", (event, link) => {
      event.preventDefault()
      link.hidden = true
      this.$("#archived-classes").show()
    })
  }
}

class SelectGradesView extends Widget {
  constructor() {
    super(document.querySelector(".grade-buttons") || document.body)
    this.delegate("change", "input[type='checkbox']", this.updateButtonStates)
    this.updateButtonStates()
  }

  updateButtonStates() {
    this.$("input[type='checkbox']").each((_, input) => {
      input.closest("label")?.classList.toggle("selected", input.checked)
    })
  }
}

class SignupView extends Widget {
  constructor() {
    super()
    this.emailInput = this.$("#user_email")
    this.emailAlert = this.$("#email-alert")
    this.delegate("blur", "#user_email", this.showEmailAlert)
    this.delegate("keyup", "#user_email", this.updateEmailAlert)
    this.updateEmailAlert()
    this.showEmailAlert()
  }

  updateEmailAlert() {
    const email = String(this.emailInput.val() || "").trim()
    this.emailAlert.text(email ? `IMPORTANT - Verify that your email is correct: ${email}` : "").toggle(Boolean(email))
  }

  showEmailAlert() {
    this.updateEmailAlert()
  }
}

class DocumentsIndexView extends Widget {
  constructor() {
    super()
    const grade = new URLSearchParams(window.location.search).get("grade")
    const documentGroups = $(".documents .wbd-card-stack .collapse, .wbd-card-stack .collapse[id^='grade-']")
    const card = grade
      ? $(`#grade-${CSS.escape(grade)}-list`)
      : documentGroups.length === 1 ? documentGroups.first() : $()

    // The first/selected document group is initial page state, so reveal it
    // immediately instead of making keyboard users and browser automation wait
    // for Bootstrap's collapse transition.
    card.addClass("show").attr("aria-expanded", "true").css({ display: "block", height: "" })
  }
}

class AssignmentFormView extends Widget {
  constructor(options = {}) {
    super()
    this.videoLessons = { rubricIds: [], ...(options.videoLessons || {}) }
    this.checkbox = this.$("#assignment_video_lessons")
    this.checkbox.addClass("wbd-native-toggle")
    this.delegate("change", "#course", this.updateForm)
    this.delegate("change", "#assignment_rubric_id", this.updateVideoLessonsToggle)
    this.updateVideoLessonsToggle()
  }

  updateForm() {
    const courseId = this.$("#course").val()
    this.$("form#new_assignment").attr("action", `/classes/${courseId}/assignments`)
    this.$("[name='assignment[rubric_id]']").attr("id", "").prop("disabled", true)
    this.$(`select[data-course-id='${courseId}']`).attr("id", "assignment_rubric_id").prop("disabled", false)
    this.updateVideoLessonsToggle()
  }

  updateVideoLessonsToggle() {
    const rubricId = String(this.$("#assignment_rubric_id").val() || "")
    const available = this.videoLessons.rubricIds.map(String).includes(rubricId)
    this.checkbox.prop("disabled", !available)
    if (!available) this.checkbox.prop("checked", false)
    this.checkbox.attr("title", available ? "" : "Unavailable for selected rubric")
  }
}

class AccountFormView extends Widget {
  constructor() {
    super()
    this.featureCheckboxes().addClass("wbd-native-toggle")
    this.delegate("change", "#account_account_type, #account_limit_type", this.updateForm)
    this.updateForm()
  }

  featureCheckboxes() {
    return this.$("#account_video_lessons, #account_ai_student_assistant, #account_ai_teacher_assistant, #account_video_library")
  }

  updateForm() {
    const accountType = this.$("#account_account_type").val()
    const limitType = this.$("#account_limit_type").val()
    const isAdmin = accountType === "admin"
    this.$('label[for="account_users_limit"]').text(isAdmin || accountType === "client" ? "User Limit" : "Teacher Limit")
    this.$("#account_students_limit").prop("disabled", isAdmin)
    this.featureCheckboxes().prop("disabled", isAdmin)
    this.$("#account_limit_type option[value='grade']").prop("disabled", isAdmin)

    if (isAdmin) {
      this.$("#grade-limit-fields").hide().find("input").val("0")
      this.$("#account_limit_type").val("user")
      this.$("#account_users_limit").prop("readonly", false).prop("required", true)
    } else if (limitType === "user") {
      this.$("#account_users_limit").prop("readonly", false).prop("required", true)
      this.$("#grade-limit-fields").hide().find("input").val("0")
    } else {
      this.$("#account_users_limit").val("").prop("readonly", true).prop("required", false)
      this.$("#grade-limit-fields").show()
    }
  }

}

class InstructionalVideoFormView extends Widget {
  constructor() {
    super()
    this.select = this.$("#rubric_instructional_video_id")
    this.initialValue = this.select.val()
    this.selectForm = this.$("#select-instructional-video-form")
    this.addNewForm = this.$("#add-new-instructional-video-form")
    this.delegate("change", "#rubric_instructional_video_id", this.updateForm)
    this.updateForm()
  }

  updateForm() {
    const value = this.select.val()
    const adding = value === "add-new"
    this.addNewForm.toggle(adding)
    this.selectForm.find(".preview-button").toggle(!adding && value !== "")
    this.selectForm.find(".submit-button").toggle(!adding && value !== this.initialValue)
  }
}

class ModalVideoPlayerView extends Widget {
  constructor(options = {}) {
    super()
    this.player = videojs("video-modal-player", { controls: true, fluid: true, ...(options.playerOptions || {}) })
    this.modal = this.$("#video-modal")
    this.modalInstance = Modal.getOrCreateInstance(this.modal[0])
    this.$("#video-modal-player").on("contextmenu", () => false)
    this.modal.on("hidden.bs.modal", () => this.player.pause())
    this.delegate("click", '[data-wbd-toggle="video-modal"]', this.showModal)
  }

  showModal(event, trigger) {
    event.preventDefault()
    const selector = $(trigger).data("selector")
    const data = (selector ? $(selector) : $(trigger)).data()
    this.modalInstance.show()
    this.player.src({ src: data.src, type: data.type })
  }
}

Object.assign(window, {
  AccountView,
  UserView,
  CoursesView,
  SelectGradesView,
  SignupView,
  DocumentsIndexView,
  AssignmentFormView,
  AccountFormView,
  InstructionalVideoFormView,
  ModalVideoPlayerView
})
